import React, { FC } from "react";

interface AsideNewArray {
    title: string;
    content: string | Array<string>;
    link?: string;
}
interface AsideNewType {
    data: AsideNewArray[];
}

const AsideNew: FC<AsideNewType> = ({ data }) => {
    return (
        <aside className="aside-new lg:text-left text-center">
            {data.map((x, i) => (
                <div key={i} className="aside-new-item p-3">
                    <h4 className="title">{x.title}</h4>
                    {x.title === "website" ? (
                        <a className="cursor-pointer" href={`https://${x.link}`} target="_blank" rel="noreferrer">
                            <p className="description underline decoration-solid">{x.content}</p>
                        </a>
                    ) : Array.isArray(x.content) ? (
                        <p className="description-list">
                            {x.content.map((eachitem, j) => (
                                <p key={j} className="description-list-item">
                                    {eachitem}
                                </p>
                            ))}
                        </p>
                    ) : (
                        <p className="description ">{x.content}</p>
                    )}
                </div>
            ))}
        </aside>
    );
};

export default AsideNew;
